module.exports = __webpack_public_path__ + "media/application/images/ui/member-icon-a64a898f958c92b50eb0d475f36eb388.png";